import React from 'react';
import PropTypes from 'prop-types';

// styles
import css from './tabs.sss';


const TabsItem = (props) => {
    return (
        <div
            onClick={props.onItemClick}
            className={props.active ? css.itemActive : css.item}
            data-qaid={props.dataQa}
            name={props.name}
        >
            <span className={css.itemText}>
                {props.children}
            </span>
            {props.mark && (
                <span className={css.mark} />
            )}
            {props.counter > 0 && (
                <span className={css.counter}>{props.counter}</span>
            )}
        </div>
    );
};

TabsItem.propTypes = {
    onItemClick: PropTypes.func,
    active: PropTypes.bool,
    mark: PropTypes.bool,
    name: PropTypes.string,
    dataQa: PropTypes.string,
    counter: PropTypes.number,
};



export const Tabs = (props) => {
    return (
        <div className={css.root}>
            {props.children}
        </div>
    );
};

Tabs.Item = TabsItem;
